import React from 'react';
import {Container, Icon, IconContainer} from './styles';
import {theme} from '../../../../styles/darkTheme/';
import RequestIcon from '../../../../assets/icons/remittance.svg';

interface Props {
  backgroundColor?: string;
  disabled?: boolean;
  onClick?: () => void;
  size?: number;
  src?: string;
  className?: any;
  submit?: boolean;
}

const CircleIconButton: React.FC<Props> = ({
  backgroundColor,
  disabled,
  onClick,
  size = 40,
  src = RequestIcon,
  className,
  submit = false,
}) => {
  return (
    <Container
      type={submit ? 'submit' : 'button'}
      className={className}
      backgroundColor={backgroundColor}
      disabled={disabled}
      onClick={onClick}
      size={size}
      theme={theme}>
      <IconContainer>
        <Icon src={src} size={size - 14} />
      </IconContainer>
    </Container>
  );
};

export default CircleIconButton;
